// Dedicated Server & Sonderposten translations

const dedicated = {
  en: {
    sonderposten: {
      title: "Dedicated Sale Servers",
      subtitle: "Grab these limited-time offers before they're gone",
      cpu: "CPU",
      ram: "RAM",
      storage: "Storage",
      extras: "Extras",
      setup: "Setup",
      setupTime: "Setup Time",
      monthly: "/month",
      configure: "Configure Now",
      soldout: "Sold Out",
      noSetupFee: "No Setup Fee",
      filter: "Search servers...",
      noResults: "No servers match your search criteria.",
    },
    dedicated: {
      standard_hero1: "Standard",
      standard_hero2: "Dedicated Servers",
      standard_desc: "Entry-level to mid-range dedicated servers with 1 Gbit/s network. Perfect for growing businesses and game servers.",
      standard_badge: "1 Gbit/s",
      standard_ctaTitle: "Need More Power?",
      standard_ctaDesc: "Check out our Premium servers with 10 Gbit/s network for maximum performance.",
      standard_ctaBtn: "View Premium Servers",
      premium_hero1: "Premium",
      premium_hero2: "Dedicated Servers",
      premium_desc: "High-end servers with 10 Gbit/s network. Enterprise-grade hardware for the most demanding workloads.",
      premium_badge: "Maximum Performance",
      premium_ctaTitle: "Looking for Deals?",
      premium_ctaDesc: "Check out our sale servers for discounted dedicated servers with no setup fee.",
      premium_ctaBtn: "View Sale Servers",
      col_server: "Server",
      col_cpu: "CPU",
      col_ram: "RAM",
      col_storage: "Storage",
      col_network: "Network",
      col_setup: "Setup",
      col_price: "Price",
      feat_ddos: "DDoS Protection",
      feat_setup_time: "1 to 7 business days",
      feat_network_1g: "1 Gbit/s Network",
      feat_network_10g: "10 Gbit/s Network",
      feat_root: "Full Root Access",
      feat_ddos_enterprise: "Enterprise DDoS",
      from: "From",
      configureNow: "Configure",
      freeSetup: "Free",
      popular: "Popular",
      bestValue: "Best Value",
      perMonth: "/month",
      viewStandard: "Standard (1 Gbit/s)",
      viewPremium: "Premium (10 Gbit/s)",
      viewSale: "Sale Servers",
      backToDedicated: "All Dedicated Servers",
    },
  },

  de: {
    sonderposten: {
      title: "Dedicated Angebots-Server",
      subtitle: "Greif zu, solange der Vorrat reicht",
      cpu: "CPU",
      ram: "RAM",
      storage: "Speicher",
      extras: "Extras",
      setup: "Einrichtung",
      setupTime: "Bereitstellungszeit",
      monthly: "/Monat",
      configure: "Konfigurieren",
      soldout: "Ausverkauft",
      noSetupFee: "Keine Einrichtungsgebühr",
      filter: "Server suchen...",
      noResults: "Keine Server entsprechen deinen Suchkriterien.",
    },
    dedicated: {
      standard_hero1: "Standard",
      standard_hero2: "Dedicated Server",
      standard_desc: "Einstiegs- bis Mittelklasse-Dedicated-Server mit 1 Gbit/s-Netzwerk. Ideal für wachsende Unternehmen und Gameserver.",
      standard_badge: "1 Gbit/s",
      standard_ctaTitle: "Mehr Leistung gefragt?",
      standard_ctaDesc: "Schau dir unsere Premium-Server mit 10 Gbit/s-Netzwerk für maximale Performance an.",
      standard_ctaBtn: "Premium Server ansehen",
      premium_hero1: "Premium",
      premium_hero2: "Dedicated Server",
      premium_desc: "High-End-Server mit 10 Gbit/s-Netzwerk. Enterprise-Hardware für anspruchsvollste Workloads.",
      premium_badge: "Maximale Leistung",
      premium_ctaTitle: "Schnäppchen gesucht?",
      premium_ctaDesc: "Schau dir unsere Angebots-Server mit reduzierten Preisen ohne Einrichtungsgebühr an.",
      premium_ctaBtn: "Angebots-Server ansehen",
      col_server: "Server",
      col_cpu: "CPU",
      col_ram: "RAM",
      col_storage: "Speicher",
      col_network: "Netzwerk",
      col_setup: "Einrichtung",
      col_price: "Preis",
      feat_ddos: "DDoS-Schutz",
      feat_setup_time: "1 bis 7 Werktage",
      feat_network_1g: "1 Gbit/s Netzwerk",
      feat_network_10g: "10 Gbit/s Netzwerk",
      feat_root: "Voller Root-Zugriff",
      feat_ddos_enterprise: "Enterprise DDoS-Schutz",
      from: "Ab",
      configureNow: "Konfigurieren",
      freeSetup: "Kostenlos",
      popular: "Beliebt",
      bestValue: "Bestes Preis-Leistungs-Verhältnis",
      perMonth: "/Monat",
      viewStandard: "Standard (1 Gbit/s)",
      viewPremium: "Premium (10 Gbit/s)",
      viewSale: "Angebots-Server",
      backToDedicated: "Alle Dedicated Server",
    },
  },
};

export default dedicated;
